import React, { createContext, useContext, useState, ReactNode } from "react";

interface FormDataContextType {
  formData: any;
  setFormData: (data: any) => void;
}

const FormDataContext = createContext<FormDataContextType | undefined>(undefined);

export const FormDataProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [formData, setFormData] = useState<any>({});

  return <FormDataContext.Provider value={{ formData, setFormData }}>{children}</FormDataContext.Provider>;
};

export const useFormData = () => {
  const context = useContext(FormDataContext);
  if (context === undefined) {
    throw new Error("useFormData must be used within a FormDataProvider");
  }
  return context;
};
